import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  subscription OnAgentMessageInfoPublished(
    $tenantId: ID!
    $zoneId: ID!
    $conversationId: ID!
  ) {
    onAgentMessageInfoPublished(
      conversationId: $conversationId
      tenantId: $tenantId
      zoneId: $zoneId
    ) {
      conversationId
      messageId
      seq
      type
      createdAt
      payload
      tenantId
      zoneId
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.OnAgentMessageInfoPublishedSubscription,
    ents.core.agent.Info.Stored,
    'onAgentMessageInfoPublished'
  >(
    'onAgentMessageInfoPublished',
    // The published shape is the entry inside out — its type and date beside a
    // JSON payload — which is the shape a listed entry has, so it is read the
    // same way.
    graphql.transformers.OUT.custom(published => {
      TypeAsserter.assertIsNotNullish(published)
      return {
        entry: fragments.messageInfo.TRANSFORMER.getEntityFrom(published),
        messageId: PartialId.from(published.messageId),
        seq: published.seq,
      }
    }),
  ),
)

export const executor = graphql.createSubscriber<
  graphql.schema.OnAgentMessageInfoPublishedSubscription,
  ents.core.agent.Info.Stored,
  graphql.schema.OnAgentMessageInfoPublishedSubscriptionVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
